import { PopularDestinationsCard } from './PopularDestinationsCard';

type Destination = {
    image: string;
    label: string;
    alt: string;
    href: string;
};

type PopularDestinationsProps = {
    heading: string;
    destinations: Destination[];
};

export const PopularDestinations = ({ heading, destinations }: PopularDestinationsProps) =>
    destinations.length > 1 ? (
        <section className="mb-32">
            <h3 className="px-16 mb-16">{heading}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-16 px-16">
                {destinations.map((dest) => (
                    <PopularDestinationsCard key={dest.image} src={dest.image} alt={dest.alt} label={dest.label} href={dest.href} />
                ))}
            </div>
        </section>
    ) : null;
